/* Bisous & Co — cadeau du 3e article (11/09/2026).
   Remplace l'ancien script « Buy 2 Get 1 Free — MR MME BISOUS » (V1), qui ne pilotait plus rien.
   - clic sur [data-bs-gift-add] : ajoute la variante avec la propriete _gift=1 (masquee dans le panier),
     puis rejoue cart:update avec les sections rendues par Shopify pour que le tiroir se redessine.
   - a chaque cart:update : si une ligne _gift existe alors qu'il y a moins de 3 articles payants,
     on la retire — sans ca la cliente paierait l'accessoire plein tarif. */
(function () {
  var GIFT_MIN = 999 /* cadeau retire le 13/09 : toute ligne _gift residuelle est purgee */;
  var busy = false;

  function sectionIds() {
    return Array.prototype.slice.call(document.querySelectorAll('cart-items-component[data-section-id]'))
      .map(function (el) { return el.dataset.sectionId; }).filter(Boolean);
  }
  function withSections(body) {
    var ids = sectionIds();
    if (ids.length) { body.sections = ids; body.sections_url = location.pathname; }
    return body;
  }
  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { if (!r.ok) throw new Error(url + ' ' + r.status); return r.json(); });
  }
  function announce(sections, sourceId) {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { resource: cart, sourceId: sourceId, data: { sections: sections || {} } }
        }));
        return cart;
      });
  }
  function split(cart) {
    var paid = 0, giftLine = 0;
    (cart.items || []).forEach(function (it, i) {
      if (it.properties && it.properties._gift === '1') giftLine = i + 1;
      else paid += it.quantity;
    });
    return { paid: paid, giftLine: giftLine };
  }

  /* Choix de la couleur : la vignette selectionnee met a jour l'image, le nom et l'id porte par la carte. */
  document.addEventListener('click', function (e) {
    var sw = e.target && e.target.closest ? e.target.closest('[data-bs-gift-swatch]') : null;
    if (!sw) return;
    e.preventDefault();
    var card = sw.closest('[data-bs-gift]');
    if (!card) return;
    card.dataset.bsGiftSelected = sw.dataset.bsGiftSwatch;
    card.querySelectorAll('[data-bs-gift-swatch]').forEach(function (b) { b.classList.toggle('is-on', b === sw); });
    var img = card.querySelector('[data-bs-gift-img]'); if (img && sw.dataset.img) img.src = sw.dataset.img;
    var name = card.querySelector('[data-bs-gift-variant-name]'); if (name) name.textContent = sw.dataset.title || '';
  }, true);

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-bs-gift-add]') : null;
    if (!btn || busy) return;
    e.preventDefault();
    var card = btn.closest('[data-bs-gift]');
    var id = parseInt((card && card.dataset.bsGiftSelected) || btn.dataset.bsGiftAdd, 10);
    if (!id) return;
    busy = true;
    btn.disabled = true;
    var body = withSections({ items: [{ id: id, quantity: 1, properties: { _gift: '1' } }] });
    post('/cart/add.js', body)
      .then(function (res) { return announce(res.sections, 'gift'); })
      .catch(function (err) { console.warn('[gift]', err); btn.disabled = false; })
      .then(function () { busy = false; });
  }, true);

  /* Filet de securite au chargement (retour depuis le checkout, onglet rouvert) :
     meme regle qu'au cart:update, sans attendre un evenement. */
  function boot() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })
      .then(function (cart) {
        var s = split(cart);
        if (!s.giftLine || s.paid >= GIFT_MIN || busy) return;
        busy = true;
        return post('/cart/change.js', withSections({ line: s.giftLine, quantity: 0 }))
          .then(function (res) { return announce(res.sections, 'gift-remove'); })
          .then(function () { busy = false; });
      }).catch(function () { busy = false; });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  document.addEventListener('cart:update', function (e) {
    if (busy) return;
    var cart = e.detail && e.detail.resource;
    if (!cart || !cart.items) return;
    var s = split(cart);
    if (!s.giftLine || s.paid >= GIFT_MIN) return;
    busy = true;
    post('/cart/change.js', withSections({ line: s.giftLine, quantity: 0 }))
      .then(function (res) { return announce(res.sections, 'gift-remove'); })
      .catch(function (err) { console.warn('[gift]', err); })
      .then(function () { busy = false; });
  });
})();

/* ── Cart timer (13/09/2026) ─────────────────────────────────────────────────
   Le markup vit dans snippets/cart-reserve-timer.liquid, les reglages dans
   Reglages du theme > Cart. Le JS est ICI parce que {% javascript %} n'est pas
   supporte dans un snippet — c'est ce qui produisait « NaN:NaN ».
   Chaque element est (re)initialise a chaque rendu du panier : le tiroir Shopify
   remplace le noeud, donc on ne peut pas se fier a un drapeau pose sur l'ancien. */
(function () {
  var KEY = 'bs_cart_timer_until';
  var timers = [];

  function paint(el, left) {
    var out = el.querySelector('[data-bs-timer-time]');
    if (!out) return;
    if (left < 0) left = 0;
    var m = Math.floor(left / 60), s = left % 60;
    out.textContent = (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
  }

  function deadline(el, fresh) {
    var mins = Number(el.getAttribute('data-minutes'));
    if (!isFinite(mins) || mins <= 0) mins = 10;
    var ms = mins * 60000;
    if (!fresh && el.getAttribute('data-restart') === 'continue') {
      try {
        var saved = Number(localStorage.getItem(KEY));
        if (isFinite(saved) && saved > Date.now()) return saved;
      } catch (e) {}
    }
    var until = Date.now() + ms;
    try { localStorage.setItem(KEY, String(until)); } catch (e) {}
    return until;
  }

  function run(el) {
    var until = deadline(el, false);
    function step() {
      var left = Math.round((until - Date.now()) / 1000);
      if (left > 0) { paint(el, left); return; }
      var mode = el.getAttribute('data-expired') || 'restart';
      if (mode === 'hide') { el.style.display = 'none'; return; }
      if (mode === 'freeze') { paint(el, 0); return; }
      until = deadline(el, true);           /* restart */
      paint(el, Math.round((until - Date.now()) / 1000));
    }
    step();
    return setInterval(step, 1000);
  }

  function boot() {
    timers.forEach(function (id) { clearInterval(id); });
    timers = [];
    document.querySelectorAll('[data-bs-timer]').forEach(function (el) {
      timers.push(run(el));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('cart:update', function () { setTimeout(boot, 0); });
})();
